"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.dispatchNewViewDerivation = exports.ViewDerivateFactory = void 0;
const utils_1 = require("../../utils");
const actions_1 = require("../../exports/store/actions");
const selectors_1 = require("../../exports/store/selectors");
const view_derivate_calendar_1 = require("./view_derivate_calendar");
const view_derivate_gallery_1 = require("./view_derivate_gallery");
const view_derivate_gantt_1 = require("./view_derivate_gantt");
const view_derivate_grid_1 = require("./view_derivate_grid");
const view_derivate_kanban_1 = require("./view_derivate_kanban");
const view_derivate_org_chart_1 = require("./view_derivate_org_chart");
const constants_1 = require("../../modules/shared/store/constants");
class ViewDerivateFactory {
    static createViewDerivate(state, datasheetId, viewType) {
        switch (viewType) {
            case constants_1.ViewType.Calendar:
                return new view_derivate_calendar_1.ViewDerivateCalendar(state, datasheetId);
            case constants_1.ViewType.Gallery:
                return new view_derivate_gallery_1.ViewDerivateGallery(state, datasheetId);
            case constants_1.ViewType.Gantt:
                return new view_derivate_gantt_1.ViewDerivateGantt(state, datasheetId);
            case constants_1.ViewType.Grid:
                return new view_derivate_grid_1.ViewDerivateGrid(state, datasheetId);
            case constants_1.ViewType.Kanban:
                return new view_derivate_kanban_1.ViewDerivateKanban(state, datasheetId);
            case constants_1.ViewType.OrgChart:
                return new view_derivate_org_chart_1.ViewDerivateOrgChart(state, datasheetId);
            case constants_1.ViewType.NotSupport:
                // Old client renders unsupported views as table views by default
                return new view_derivate_grid_1.ViewDerivateGrid(state, datasheetId);
            case constants_1.ViewType.Form:
                throw new Error('Form view is should not be derivate');
        }
        (0, utils_1.assertNever)(viewType);
    }
}
exports.ViewDerivateFactory = ViewDerivateFactory;
const dispatchNewViewDerivation = (store, datasheetId, viewId, affectRecords, affectFields) => {
    const state = store.getState();
    const currentViewId = (0, selectors_1.getActiveViewId)(state);
    const view = (0, selectors_1.getViewInNode)(state, datasheetId, viewId || currentViewId);
    if (!view || !view.rows) {
        return;
    }
    const timeStart = Date.now();
    const viewDerivate = ViewDerivateFactory.createViewDerivate(state, datasheetId, view.type);
    const viewDerivation = viewDerivate.getViewDerivation(view, affectRecords, affectFields);
    console.log('DERIVATE: calcViewDerivation %s  %s cost: %s ms', datasheetId, view.id, Date.now() - timeStart);
    store.dispatch((0, actions_1.setViewDerivation)(datasheetId, {
        viewId: view.id,
        viewDerivation,
    }));
};
exports.dispatchNewViewDerivation = dispatchNewViewDerivation;
//# sourceMappingURL=factory.js.map